import hexabaseState from '@/store/hexabase';
import BaseModel from '../baseModel';

/* eslint-disable @typescript-eslint/camelcase */
export interface Payload {
  conditions?: {
    id: string;
    search_value: Array<string>;
  }[];
  sort_fields?: [
    {
      id: string;
      order: 'desc' | 'asc';
    }
  ];
  per_page?: number;
  page?: number;
  use_display_id?: boolean;
}

export default class Staff extends BaseModel {
  // マスターDB名
  private dbName = 'm_staff';

  payload?: Payload;

  constructor(payload?: Payload) {
    super(payload);
    const defaultPayload = {
      conditions: [],
      per_page: 0,
      page: 1,
      use_display_id: true,
      return_number_value: true
    };
    this.payload = payload ? payload : defaultPayload;
  }

  async init() {
    // 検索条件payloadを使用して、APIから値を取得、各モデル値にセットする
    return await this.getItemList(hexabaseState.applicationId, this.dbName, this.payload);
  }

  async getData() {
    const data = await this.init();
    for (const key in data) {
      data[key].id = Number(data[key].id);
    }
    return data;
  }

  async getFormatData() {
    return await this.init().then(data => this.modifyMasterData(data, 'id', 'm_staff'));
  }
}
